import ApiService from '@/core/services/api.service';

const commonMixin = {
  created: function() {},
  methods: {
    fetchCompany: async function() {
      return ApiService.get('/company').then(response => {
        return response.data;
      });
    },
    fetchDepartments: async function() {
      return ApiService.query('departments/all').then(response => {
        return response.data;
      });
    },
    fetchStores: async function() {
      return ApiService.get('/stores/getStores').then(response => {
        return response.data;
      });
    },
    fetchOrderSources() {
      const params = {
        status: 1
      };
      return ApiService.query(`orderSources/getAll`, {
        params: params
      }).then(response => {
        return response.data;
      });
    },
  }
};
export default commonMixin;
